import { useParams } from "react-router-dom";
import DuaPlayerClient from "./PlayerClient";

export default function DuaPlayerPage() {
  const { duaId = "" } = useParams();
  return <DuaPlayerClient duaId={duaId} />;
}
